import {
  BaseEvent,
  BasePlugin,
  BaseStats,
  ErrorInfo,
  EventIds,
  EventLevel,
  mergePluginOption,
  ResourceErrorInfo,
} from '@fpkg/stats-core';
import { detectBlankScreenOnError, DetectBlankScreenOpts } from '../data-capture-funcs/blankScreen';

export interface BlankScreenOpt {
  rootSelector?: string; // 计算白屏的dom根节点，支持querySelector语法。
  threshold?: number; // dom阈值,如果小于阈值,则认为可能是白屏。
  event_level?: EventLevel;
}

export default class BlankScreenPlugin implements BasePlugin {
  name = 'blankScreen';

  stats?: BaseStats;

  option: BlankScreenOpt = {
    rootSelector: '',
    threshold: 1.5,
    event_level: EventLevel.ERROR, // 白屏事件统一为error级别
  };

  domCount = 0;

  constructor(option: BlankScreenOpt | null | boolean) {
    mergePluginOption(this.option, option);
  }

  setup(stats: BaseStats): void {
    this.stats = stats;
    // 发生js异常去判断是否白屏
    this.stats.$bus.$on('ON_JS_ERROR', (info: ErrorInfo) => {
      this.detectBlankScreen(info, this.option);
    });
    // 发生资源加载异常时，5秒后去判断是否白屏
    this.stats.$bus.$on('ON_RESOURCE_ERROR', (info: ResourceErrorInfo) => {
      this.detectBlankScreen(info, this.option);
    });
  }

  detectBlankScreen(errorInfo: BaseEvent, option: DetectBlankScreenOpts, microApp?: string) {
    detectBlankScreenOnError(errorInfo, option, (reportInfo: BaseEvent) => {
      const info = { ...reportInfo };
      if (microApp) {
        info.micro_app = microApp;
      }
      this.handlerBlankScreen(info);
    });
  }

  handlerBlankScreen(info: BaseEvent) {
    const eventInfo = {
      ...info,
      event: EventIds.BlankScreen,
      event_name: '白屏异常',
      event_code: 'blank_screen_by_count_dom',
      event_type: info.event,
      event_level: EventLevel.ERROR,
    };

    if (this.stats) {
      // 白屏异常需要上报到顺丰云和神策
      this.stats.event(eventInfo);
      this.stats.$bus.$emit('ON_BLANK_SCREEN_EVENT', eventInfo);
    }
  }
}
